import TreeTableWithSlider from "./TreeTableWithSlider.jsx";

export default TreeTableWithSlider;



// WEBPACK FOOTER //
// ./src/components/common/treeTableWithSlider/index.js